// removed by extract-text-webpack-plugin
module.exports = {"LeftRightButtonArrows":"purify_LeftRightButton__LeftRightButtonArrows___1-JK6","LeftRightButton":"purify_LeftRightButton__LeftRightButton___bR9NO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/buttons/HardwareButton/LeftRightButton/LeftRightButton.scss
// module id = 193
// module chunks = 0